import { createAuthenticationContainer } from './createAuthenticationContainer'

export const container = createAuthenticationContainer({
	path: '/:country/:sessionId',
	getCountry: ({ country }) => country,
})
